import { render, staticRenderFns } from "./edit-address-book-modal.vue?vue&type=template&id=5a67afe4"
import script from "./edit-address-book-modal.vue?vue&type=script&lang=js"
export * from "./edit-address-book-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports